export function sanitizeUrl(url: string): string | null {
  if (!url || !url.trim()) return null;
  let normalized = url.trim();
  if (!normalized.match(/^https?:\/\//i)) {
    normalized = `https://${normalized}`;
  }
  try {
    const parsed = new URL(normalized);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return parsed.href;
  } catch {
    return null;
  }
}

export function sanitizeInternalPath(raw: string | null | undefined): string | null {
  if (!raw) return null;
  try {
    // Only allow relative paths beginning with a single '/'
    if (!raw.startsWith('/')) return null;
    // Disallow protocol-relative or external URLs
    if (raw.startsWith('//')) return null;
    // Disallow attempts to inject protocol (AUTH-06 security fix)
    if (raw.includes('://')) return null;
    // Block javascript: and data: pseudo-protocols
    const lowerRaw = raw.toLowerCase();
    if (lowerRaw.includes('javascript:') || lowerRaw.includes('data:')) return null;
    // Basic normalization to avoid CRLF or control chars
    const cleaned = raw.replace(/[\r\n\t]/g, '');
    // Remove any potential path traversal attempts
    if (cleaned.includes('../') || cleaned.includes('..\\')) return null;
    // Ensure path doesn't contain null bytes
    if (cleaned.includes('\0')) return null;
    return cleaned;
  } catch {
    return null;
  }
}


